/**
 * Universal nav: scroll the active link into view on load and resize.
 * Moved out of snippets/cusa-universal-nav.liquid (inline).
 */
const scrollToActiveLink = () => {
	const universalNav = document.querySelector('#universal-nav');
	const navContent = universalNav.querySelector('.nav-content');
	const activeNavLink = navContent.querySelector('a.active');
	if (activeNavLink) {
		universalNav.scrollTo({
			left: activeNavLink.offsetLeft - parseFloat(getComputedStyle(navContent).paddingLeft),
			behavior: 'smooth'
		});
	}
};
document.addEventListener('DOMContentLoaded', function () {
	scrollToActiveLink();
});
window.addEventListener('resize', scrollToActiveLink, false);
